import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { AccesibilidadContext, TemasDisponibles } from "../../contexts/AccesibilidadContext";
import { ContentHeader } from "./components/content-header";
import { BenefitsSection } from "./components/benefits-section";
import { RequirementsSection } from "./components/requirements";
import { HelpSection } from "./components/help-section";
import { Tutorials } from "./components/tutorials";
import { FAQSection } from "./components/faq";
import { RegionSection } from "./components/region-section";
export const PilotoRNBP = () => {
	const title = "Segunda Fase Proyecto Piloto de Lectura Digital Bibliotecas Públicas - RNBP";
	const mainDescription = "Proyectos de lectura digital para el sector publico, RNBP";
	const accesibility = useContext(AccesibilidadContext);
	const isHighContrast = accesibility.temaActual === TemasDisponibles.altoContraste.id;

	return (
		<div className="piloto-rnbp">
			<Helmet>
				<title>MakeMake - {title}</title>
				<meta name="description" content={mainDescription} />
			</Helmet>
			<div className="">
				<ContentHeader
					title={title}
					backgroundColor={isHighContrast ? "var(--secondary-inverse)" : "#6666cc"}
					color={isHighContrast ? "var(--onsecondary-inverse)" : "#fff"}
				/>
				<div className="container piloto-rnbp-content p-0">
					<p className="secondary-font main-description pt-5 pb-3 p-3 onbackground-primary--color">
						La Red Nacional de Bibliotecas Públicas - RNBP seleccionó{" "}
						<span className="primary-inverse--bg onprimary-inverse--color">
							100 bibliotecas
						</span>{" "}
						para participar en la Segunda Fase Proyecto Piloto de Lectura Digital por
						medio de la plataforma MakeMake. Las bibliotecas tendrán acceso por un año
						y contarán con sesiones y material de capacitación.
					</p>
					<RegionSection/>
					<BenefitsSection />
					<RequirementsSection/>
					<Tutorials/>
					<FAQSection/>
					<HelpSection/>
					<div className="d-flex justify-content-center align-items-center my-5">
					<img className="img-fluid mb-3" style={{maxWidth:'800px'}} src="/img/piloto-rnbp/logos.png" alt="logos"/>
					</div>
				</div>
			</div>
		</div>
	);
};
